import { motion } from "framer-motion";
import React, { useState } from "react";
import { FiCopy } from "react-icons/fi";
import OfferImg from "../../assets/limited_offfer_img.png";

function GetFreeCredits() {
  const [copiedIndex, setCopiedIndex] = useState(null);

  const messages = [
    "Tried something new this week: a 45-minute personality test by www.SelfSync.ai. Surprisingly accurate, incredibly insightful. Perfect for hiring, promoting, or realigning teams. Worth a shot if you're building teams or thinking about internal promotions.",
    "Just tried www.SelfSync.ai — a 45-minute AI-powered personality test that gives you deep clarity on people, roles, and team fit. Perfect for hiring, promoting, or realigning teams. If you're building or leading a team — check this out. Wishing the team all the best on this exciting launch!",
    "Just tried www.SelfSync.ai — and loved the experience. It's a simple, AI-powered personality test that gives deep insights into how people fit into roles and teams.",
    "Just experienced www.SelfSync.ai and was genuinely impressed. It's a fast, AI-powered personality test that helps companies make smarter hiring, promotion, and team decisions. Highly recommended for leaders building aligned, high-performing teams.",
    "Just tried out www.SelfSync.ai — and wow. In 45 minutes, it gave me more clarity about personality fit, leadership potential, and team alignment than most interviews or resumes ever could. If you're hiring, promoting, or just want to understand your team better — this is a tool worth checking out. Highly recommend it for founders, HRs, and team leads.",
    "Hiring, promoting, or realigning your team? Try www.SelfSync.ai. No fluff. Just real, actionable insights on who fits where and why. One of the few tools that actually delivers what it promises.",
  ];

  const copyToClipboard = (text, index) => {
    navigator.clipboard.writeText(text);
    setCopiedIndex(index);
    setTimeout(() => setCopiedIndex(null), 2000);
  };

  return (
    <div className="p-10 max-md:p-4 overflow-hidden ">
      <motion.div className="text-start mb-10"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        <h1 className="text-2xl max-md:text-2xl font-bold text-black max-md:ml-10">
          Post & Prosper: Get 3 Extra Credits — On Us!
        </h1>
        <p className="text-sm text-start text-gray-500 mb-6 max-w-3xl ">
          We love when our users spread the word — so here's a little thank you
          for helping us grow!
        </p>
      </motion.div>

      <motion.div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-md:gap-2 bg-violet-200/30 py-4 rounded-lg shadow-lg justify-star items-start"
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        <div className="relative overflow-hidden rounded-3xl px-4  mb-10">
          <div className="relative z-10">
            <div className="flex max-md:justify-center ">
              <img src={OfferImg} alt="OfferImg" className="h-20" />
            </div>
            <div className="space-y-3 text-start text-lg">
              <p>
                After signing up for our free plan, you already get{" "}
                <span className="font-semibold text-violet-900">
                  2 assessment credits
                </span>{" "}
                to experience SelfSync.ai
              </p>
              <p>
                Now, we're giving you{" "}
                <span className="font-semibold text-violet-900">
                  3 more FREE credits
                </span>{" "}
                — just for sharing your experience
              </p>
            </div>
          </div>
        </div>

        <div className="mb-6 p-2 r max-md:p-2">
          <div className="flex items-center mb-6 max-md:justify-center">
            <h2 className="text-xl font-semibold text-black">
              Here's how it works:
            </h2>
          </div>

          <ul className="space-y-4 pl-2">
            <li>
              Post any one of the messages below on your LinkedIn, Instagram, or
              Twitter
            </li>
            <li>
              Tag or mention{" "}
              <span className="text-violet-700 font-semibold">
                @SelfSync.ai
              </span>{" "}
            </li>
            <li>
              Send us a screenshot of your post to 👉{" "}
              <span className="font-semibold text-violet-700">
                credits@selfsync.ai
              </span>
            </li>
            <li>
              Once verified, we'll instantly add{" "}
              <span className="font-bold text-violet-700">
                3 bonus assessment credits
              </span>{" "}
              to your account
            </li>
          </ul>
        </div>
      </motion.div>

      <hr className="py-2" />

      <motion.div className="mb-6"
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        <h2 className="text-xl font-semibold text-black mb-6 flex items-center">
          Ready-to-Post Message Options:
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {messages.map((message, index) => (
            <div
              key={index}
              className="bg-white p-5 rounded-lg border border-gray-200 relative h-full flex flex-col"
            >
              {/* Message content */}
              <div className="flex justify-between items-start mb-3">
                <h3 className="font-medium text-black bg-violet-100 rounded-md px-2 py-1">
                  Choice {index + 1}
                </h3>

                <div className="relative group">
                  <button
                    onClick={() => copyToClipboard(message, index)}
                    className="text-indigo-600 hover:text-indigo-800  rounded-full bg-violet-100 p-2 hover:bg-indigo-50 transition"
                    aria-label="Copy to clipboard"
                  >
                    <FiCopy className="w-5 h-5" />
                  </button>
                  <div className="absolute -top-8 right-0 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
                    {copiedIndex === index ? "Copied!" : "Copy"}
                    <div className="absolute bottom-0 right-2 -mb-1 w-2 h-2 bg-gray-800 transform rotate-45"></div>
                  </div>
                </div>
              </div>
              <div className="flex-grow">
                <p className="whitespace-pre-line text-gray-700">{message}</p>
              </div>
            </div>
          ))}
        </div>
      </motion.div>

      <motion.div className="bg-green-50 p-4 rounded-lg border border-green-200 mt-8"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        <p className="text-green-800 font-medium text-center">
          💬 Help others discover SelfSync. You grow. We grow. Everyone wins.
        </p>
      </motion.div>
    </div>
  );
}

export default GetFreeCredits;
